import Head from "next/head";
import prisma from "../lib/prisma";
import FindAnAgentComp from '../components/FindAnAgent/FindAnAgent'
import { Listing, Prisma } from "@prisma/client";
import { SpinnerHolder } from "../styles/ListingsStyles";
import { Spinner } from "@chakra-ui/react";
import { AgentsGetter, shuffle } from "../src/apiUtility";


const FindAnAgent = ({ staticData }) => {
    
    return (
        <>
            <Head>
                <title key="title">
                    Find an Agent for your Business or Commercial Real Estate Investment
                </title>
                <meta
                    key="og:title"
                    property="og:title"
                    content="Find an Agent for your Business or Commercial Real Estate Investment"
                />
                <link rel="canonical" href="https://zonado.com/agents" />
            </Head>
            <FindAnAgentComp
                staticData={staticData}
            />

        </>
    )

}

export default FindAnAgent;

export async function getStaticProps() {
    const page = 1;
    const props = {page}
    const results = await AgentsGetter(props)
    return {
        props: {
            staticData: {
                ...results
            }
        },
        revalidate: 3600, // In seconds
    }

}